__turbopack_context__.v({
  "body": "RewardsHeader-module__EBMrBq__body",
  "header": "RewardsHeader-module__EBMrBq__header",
  "heading": "RewardsHeader-module__EBMrBq__heading",
  "titleRow": "RewardsHeader-module__EBMrBq__titleRow",
});
